import { render, staticRenderFns } from "./ReportFilter.vue?vue&type=template&id=36a1464c"
import script from "./ReportFilter.vue?vue&type=script&lang=js"
export * from "./ReportFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports